
export const TEXT_CONTENT = {
    charts : {
        title : 'Charts',
        text : "In XXI century there are some tricky improvements like credit cards. It's realy easy to use but it's harder to visualize how much money you're spending everyday. We know this problems and we're facing them with our App that visualize your money flow. We're using charts to make this datas more readable and clear.",
        imageUrl : "https://h5p.org/sites/default/files/styles/medium-logo/public/logos/chart-icon-color.png?itok=kpLTYHHJ",
        bgColor : "rgba(175, 179, 247, 0.215)"
    },
    free: {
        title: 'Free to use',
        text: "This App purerly arised out of need to track my money outflow and some credit rates tracking. If this App will help you too - good for you. But for now it's completely free",
        imageUrl: "https://icons.veryicon.com/png/o/business/gray-tri-color-business-icon/money-41.png",
        bgColor : "rgba(179, 247, 175, 0.215)"
    },
    timeline : {
        title: 'Timeline',
        text: "Have you ever been unsure if you already paid installment in current month ? Did you ever have to check this in your bank account history ! Wallet Chart will do this for you. Now datas provided by you are shown as timeline !",
        imageUrl: "https://icon-library.com/images/timeline-icon-png/timeline-icon-png-12.jpg",
        bgColor : "rgba(247, 179, 175, 0.215)"
    },
    questionArray: [
        "Did I pay loan installment this month ?",
        "How much credit do I have left?",
        "How much money did I spent for ... this month ? ",
        "Can I spent less monthly ?"
    ],
    scienceArray : [
        "Did you know that if you can not make any savings - it's probably not that your salary is too low, but your spendings are not customized to your salary? What's more - probably you even don't know about that. Think about how many times you bought something on the spur of the moment, this month. ",
        "Probably you remember from 3 to 5 situations like that. So it's maybe 50-100 PLN lost monthly. Guess what - it's not even close. With WalletChart App, relying on your data completion - you will see the real amount of lost money for unnecessary things.",
        "Taking control over your finance is the first step to make some savings and to understand your bad financial habits. After 1-2 months of consequence in tracking money - you'll be able to introduce 'repair plan' to your budget."
    ],
    tiles : [
        {
            header : "Real view",
            text : "You'll see real amount of money you're spending monthly for necesary and unnecessary things",
            color : "rgba(247, 179, 175, 0.215)",
            iconUrl : "https://static.vecteezy.com/system/resources/thumbnails/010/150/710/small/eye-icon-sign-symbol-design-free-png.png",
            iconAlt: "View"
        },
        {
            header : "Real view",
            text : "You'll see real amount of money you're spending monthly for necesary and unnecessary things",
            color : "rgba(175, 255, 175, 0.215)",
            iconUrl : "https://static.vecteezy.com/system/resources/thumbnails/010/150/710/small/eye-icon-sign-symbol-design-free-png.png",
            iconAlt: "View"
        }
    ]
}
